// XpBar — promoted from learner-app/components/gamification/XpBar
// to @flowgenix/shared-ui (Phase 2 / Step C-3.3).
//
// Renderer for the `xp_bar` widget kind. Pure React + Flexbox CSS; no
// browser-only APIs, no react-i18next, no game-engine coupling. Safe to
// embed inside Atlas Catalog previews and any consumer that has not
// wired an i18n provider.
import React from 'react';
import './XpBar.css';

export default function XpBar({ xpCurrent, xpToNext, level, levelName, xpEarned }) {
  const pct = xpToNext > 0 ? Math.min((xpCurrent / xpToNext) * 100, 100) : 100;

  return (
    <div className="xp-bar-container">
      <div className="xp-bar-header">
        <span className="xp-level-badge">Lv {level}</span>
        <span className="xp-level-name">{levelName}</span>
        {xpEarned > 0 && <span className="xp-earned-popup">+{xpEarned} XP</span>}
      </div>
      <div className="xp-bar-track">
        <div className="xp-bar-fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="xp-bar-footer">
        <span>{xpCurrent} / {xpToNext} XP</span>
      </div>
    </div>
  );
}

XpBar.kind = 'xp_bar';
XpBar.displayName = 'XpBar';
